import { render, staticRenderFns } from "./NewYearGen.vue?vue&type=template&id=274d092f&scoped=true&"
import script from "./NewYearGen.vue?vue&type=script&lang=js&"
export * from "./NewYearGen.vue?vue&type=script&lang=js&"
import style0 from "./NewYearGen.vue?vue&type=style&index=0&id=274d092f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d092f",
  null
  
)

export default component.exports